import React from 'react'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { compose, ReduxWrapper } from 'common-data/datahelpers'
import { ListGroupItem, ListGroupItemHeading, ListGroupItemText } from 'reactstrap'

class DataGridFilterLayoutBoxPlain extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    title: pt.string,
    description: pt.string,
    children: pt.any
  })

  render () {
    const { children, title, description } = this.props

    return <ListGroupItem key={title}>
      <ListGroupItemHeading>{title || 'Title?'}</ListGroupItemHeading>
      {description
        ? <ListGroupItemText>{description}</ListGroupItemText>
        : null
      }
      {children}
    </ListGroupItem>
  }
}

export const DataGridFilterLayoutBox = compose(
  ReduxWrapper([
  ],
  [])
)(DataGridFilterLayoutBoxPlain)
